import { parseResponse } from '$lib/client/responseHelpers';

import { client, silentClient } from '@api/client';
import type { ChooseGift, RequestGift, SendCustomGift, SendGift } from '@api/types';
import type { GiftViewPlace } from '@shared/types/gift';

export const getGiftList = async (place?: GiftViewPlace) => {
    const data =  await client.GET('/gift/list', {
        params: { query: { place } },
    });
    return parseResponse<ChooseGift[]>(data);
};

export const requestGift = async (body: RequestGift) => {
    const data =  await client.POST('/gift/request', {
        body,
    });
    return parseResponse(data);
};

export const sendGift = async (body: SendGift) => {
    const data =  await client.POST('/gift/send', {
        body,
    });
    return parseResponse(data);
};

export const sendCustomGift = async (body: SendCustomGift) => {
    const data =  await silentClient.POST('/gift/send/custom', {
        body,
    });
    return parseResponse(data);
};
